export const wizardAttack = new Image();
wizardAttack.src = "./assets/characterSprites/Evil_Wizard_2/Attack1.png";
wizardAttack.width = 2000/8
// wizardAttack.height = wizardAttack.height/1
wizardAttack.yOffset = -25
wizardAttack.xOffset = -40
wizardAttack.cycleLoop = [0, 1, 2, 3, 4, 5, 6, 7];
